
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    type: { type: String, default: "default" },
    name: { type: String, default: "" },
    block: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
  },
});
